// 新聞文章頁 - 免責聲明
import Image from 'next/image';

const NewsDisclaimer = ({ t }) => {
    return (
        <div className="rounded-[2px] px-[27px] pt-[12px] pb-[20px] bg-black1 space-y-[11px]">
            <div className="flex items-center gap-x-[12px] justify-start">
                <Image
                    className="dark:hidden"
                    width={20}
                    height={20}
                    src="/images/icon/icon_disclaimer.svg"
                    alt="icon"
                />
                <Image
                    className="hidden dark:block"
                    width={20}
                    height={20}
                    src="/images/icon/icon_dark_disclaimer.svg"
                    alt="icon"
                />
                <span className="text-pale9 text-bd2b">{t('DISCLAIMER')}</span>
            </div>

            <p className="text-bd1m text-pale9 text-left">
                {t('DISCLAIMER_0')}
                <span className="underline">{t('DISCLAIMER_1')}</span>
                {t('DISCLAIMER_2')}
            </p>
        </div>
    );
};

export default NewsDisclaimer;
